import styled, { css } from 'styled-components'
import { FlatButton } from '@sketch/components'
import { ReactComponent as CanvasPageSvg } from '@sketch/icons/canvas-17'
import { ReactComponent as PrototypeSvg } from '@sketch/icons/prototype-17'
import { ReactComponent as PlaySquareSvg } from '@sketch/icons/play-square-17'
import { ReactComponent as ExclamationMarkIcon } from '@sketch/icons/exclamation-mark-triangle-24'

export const ListContainer = styled.div`
  max-height: 325px;
  overflow-y: auto;
  margin-left: 20px;
`

const iconStyles = css`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  width: 17px;
  height: 17px;
  flex: none;
  margin-right: 4px;
`

export const PageIcon = styled(CanvasPageSvg)`
  ${iconStyles}
`

export const AllPrototypesIcon = styled(PrototypeSvg)`
  ${iconStyles}
`

export const PrototypeIcon = styled(PlaySquareSvg)`
  ${iconStyles}
`

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  gap: 16px;
`

export const SearchActions = styled.div`
  display: flex;
`

export const SearchButton = styled(FlatButton)`
  padding: 4px 8px;
  text-decoration: underline;
  font-size: ${({ theme }) => theme.fontSizes.E};
`

export const Header = styled.p`
  /* has to be important because paragraphs have a default padding bottom of 20  */
  padding-bottom: 16px !important; /* stylelint-disable-line declaration-no-important */
  font-size: ${({ theme }) => theme.fontSizes.E};
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  word-wrap: break-word;
  overflow-wrap: break-word;
`

export const ErrorIcon = styled(ExclamationMarkIcon)`
  width: 24px;
  height: 24px;
  flex: none;
  color: ${({ theme }) => theme.colors.state.disabled};
`

export const TryAgainButton = styled(FlatButton)(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.C};
    text-decoration: underline;
    color: ${theme.colors.sketch.A};
    font-weight: ${theme.fontWeights.semibold};
  `
)
